import type { EcommerceSliderSlide } from '../../types';

export const ECOMMERCE_SLIDER_MAX_SLIDES = 5;
export const ECOMMERCE_SLIDER_CARD_COLOR_DEFAULT = '#2b6aa3';
export const ECOMMERCE_SLIDER_BUTTON_TEXT_DEFAULT = 'Ver más';
export const ECOMMERCE_SLIDER_INTERVAL_MS = 5000;

export function createBlankSliderSlide(): EcommerceSliderSlide {
  return {
    imageUrl: '',
    mobileImageUrl: '',
    tag: '',
    title: '',
    description: '',
    buttonText: ECOMMERCE_SLIDER_BUTTON_TEXT_DEFAULT,
    buttonUrl: '',
  };
}

function clip(value: unknown, max: number): string {
  return typeof value === 'string' ? value.slice(0, max) : '';
}

export function normalizeEcommerceSliderSlides(value: unknown): EcommerceSliderSlide[] {
  if (!Array.isArray(value) || value.length === 0) {
    return [createBlankSliderSlide()];
  }

  return value.slice(0, ECOMMERCE_SLIDER_MAX_SLIDES).map((slide) => {
    const source = slide && typeof slide === 'object' ? (slide as EcommerceSliderSlide) : {};
    return {
      imageUrl: typeof source.imageUrl === 'string' ? source.imageUrl : '',
      mobileImageUrl: typeof source.mobileImageUrl === 'string' ? source.mobileImageUrl : '',
      tag: clip(source.tag, 30),
      title: clip(source.title, 60),
      description: clip(source.description, 180),
      buttonText:
        typeof source.buttonText === 'string'
          ? source.buttonText.slice(0, 25)
          : ECOMMERCE_SLIDER_BUTTON_TEXT_DEFAULT,
      buttonUrl: typeof source.buttonUrl === 'string' ? source.buttonUrl : '',
    };
  });
}
